import axios from 'axios';
import {MutationNames} from '@/constants/MutationNames';
import store from '@/store';

export default() => {
  let baseURL = 'https://waspas.carwashstroet.be/api';

  // eslint-disable-next-line no-undef
  if (process.env.NODE_ENV === 'production') {
    // eslint-disable-next-line no-undef
  } else if (process.env.NODE_ENV === 'test') {
    baseURL = 'https://waspas.carwashstroet.be/api';
  } else {
    baseURL = 'http://stroet.local/api';
  }

  const api = axios.create({
    baseURL,
  });

  api.interceptors.response.use((res) => {
    return res;
  }, (err) => {
    if (err.response.status === 401) {
      store.commit(MutationNames.LOG_OUT);
    } else {
      return Promise.reject(err);
    }
  });

  return api;
};
